// extracted by mini-css-extract-plugin
module.exports = {"curtain":"styles_curtain__t3XNl","show-curtain-keyframes":"styles_show-curtain-keyframes__hX4cq"};